import React from "react";
import swal from "sweetalert";
import { withTranslation } from "react-i18next";
import Popper from "@material-ui/core/Popper";
import {withStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import Autocomplete from "@material-ui/lab/Autocomplete";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import TextField from "@material-ui/core/TextField";
import ApiServices from "../../api/api";
import Grid from "@material-ui/core/Grid";
import Select from "@material-ui/core/Select";
import Card from "@material-ui/core/Card";
import LockOpenIcon from "@material-ui/icons/LockOpen";
import CardContent from "@material-ui/core/CardContent";
import LocalHospitalIcon from "@material-ui/icons/LocalHospital";
import { connect } from "react-redux";
import CheckboxQues from "./checkbox";
import RadioElements from "./radioElements";
// import Attachmentpopup from "./attachmentpopup.js";
import { logError } from "../../helpers/auth";

const useStyles = (theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    width: "-webkit-fill-available",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
    backgroundColor: "rgba(0, 0, 0, .02)",
  },
});

let dependantquestionArr = [];

class Questionnaire extends React.Component {
  constructor(props) {
    super(props);
   
    this.state = {
      values: props.question.response != undefined ? props.question["response"]["value"][0] : '',
      questionlist: [],
      dependantquestionlist: [],
      dependantquestionArr: [],
      isLoading: false,
      showSlider: true,
      selecval: '',
      temp: false,
      animCssClasses: "animate__animated animate__zoomIn animate__faster",
    };
    this.handleChangeCheckbox = this.handleChangeCheckbox.bind(this)
    this.handleChangeRadio = this.handleChangeRadio.bind(this)
    this.handleselectChange = this.handleselectChange.bind(this)
    this.inputChangevent = this.inputChangevent.bind(this)
    this.getDropdownDepened = this.getDropdownDepened.bind(this)
  }

  componentDidMount() {
    if(this.props.question.type == "dropdown" && this.props.question.response != undefined){
      this.setState({ selecval: this.props.question.response.value[0] })
      this.getDropdownDepened(this.props.question.response.value[0])
    }
  }

  static getDerivedStateFromProps(nextProps) {
    // console.log(
    //   "getDerivedStateFromProps>>",
    //   JSON.stringify(nextProps.animCssClasses)
    // );
    return {
      animCssClasses: nextProps.animCssClasses,
      showSlider: nextProps.showSlider,
    };
  }

  callsameCompomnet = () => {
    const { classes } = this.props;
    if (this.state && this.state.dependantquestionlist && this.state.dependantquestionlist.length > 0) {
      return this.state.dependantquestionlist.map((Obj, index) => {
        return (
          <Questionnaire
            key={index}
            question={Obj}
            classes={classes}
            componentbgcolor={this.props.componentbgcolor}
          />
        );
      });
    }
    //return null;
  };

  updateUrl(url, type) {
    this.props.updateUrl(url, type)
  }

  renderQuestion() {
    const { classes } = this.props;
    var element = this.props.question;
    const { templateID } = this.props;
    let bgStyles = templateID == 2 ? { background: this.props.componentbgcolor } : {};
    let colorStyles = templateID == 2 ? { color: this.props.componentbgcolor } : {};
    var quslist = [];

    return (
      <>
        {
          templateID == 1 ? (
            <Card className="infocard">
              <CardContent className="pt-0px pb-0px">
                <Grid container spacing={3} className="gridcontainer border-bottom-grey">
                  <Grid item xs={2} className="text-center hospitaliconholder color-purple">
                    <LocalHospitalIcon />
                  </Grid>
                  <Grid item xs={10} className="text-left">
                    <p className="hospitalinfo">
                      {element.question}
                      {element.isMandatory && <sup className="text-red">*</sup>}
                    </p>
                  </Grid>
                </Grid>
                <Grid container spacing={3} className="gridcontainer">

                  <Grid item xs={12} className="text-left reportdetailedtextholder">
                    <div className="reportform">
                      <FormControl component="fieldset" className={classes.formControl}>
                        <FormGroup>{this.getQuestionType(element)}</FormGroup>
                      </FormControl>
                      {
                        this.callsameCompomnet()
                      }
                    </div>
                  </Grid>
                </Grid>
                {/* <Grid container spacing={3} className="gridcontainer border-top-grey">
                  <Grid item xs={12} className="text-left color-purple">
                    <EvidenceCapture updateUrl={this.updateUrl}></EvidenceCapture>
                  </Grid>
                </Grid> */}
              </CardContent>
            </Card>
          ) : (
            <>
              <Grid
                key={element.id}
                container
                spacing={0}
                className="gridcontainer chatuserlistdiv"
              >
                <Grid item xs={2} className="zero">
                  <p className="zero  text-center forumicon">
                    <LockOpenIcon style={bgStyles} />
                  </p>
                </Grid>
                <Grid item xs={10} className="zero">
                  <p className="zero chatusername" style={colorStyles}>
                    {element.question}
                    {element.isMandatory && <sup className="text-red">*</sup>}
                  </p>
                </Grid>
              </Grid>
              <div className={classes.root}>
                <div className="reportform">
                  <FormControl component="fieldset" className={classes.formControl}>
                    <FormGroup>{this.getQuestionType(element)}</FormGroup>
                  </FormControl>
                  {
                    this.callsameCompomnet()
                  }
                </div>
              </div>
            </>
          )
        }
      </>
    );
  }

  getQuestionType(element) {
    var type = element.type ? element.type.toLowerCase() : ''
    switch (type) {
      case "text":
        return this.getTextType(element);
      case "date":
        return this.getDateType(element);
      case "radio":
        return this.getRadioType(element);
      case "dropdown":
        return this.getDropDownType(element);
      case "checkbox":
        return this.getCheckboxType(element);
      case "number":
        return this.getNumberType(element);
      default:
        return this.getTextType(element);
    }
  }


  handleChangeCheckbox(values, isInputChecked) {
    console.log(values, isInputChecked)
    if (isInputChecked) {
      dependantquestionArr.push(values)
    } else {
      dependantquestionArr = dependantquestionArr.filter(c => c !== values)
    }
    if (this.props && this.props.question && this.props.question.dependentQuestionsList && this.props.question.dependentQuestionsList.length > 0) {
      var dependList = this.props.question.dependentQuestionsList.filter(o => o.selectedOption.some(r => dependantquestionArr.includes(r)))
      this.setState({ dependantquestionlist: dependList })
    }
  }


  handleChangeRadio(values) {
    //console.log(values)
    //console.log(this.props.question.dependentQuestionsList)
    if (this.props && this.props.question && this.props.question.dependentQuestionsList && this.props.question.dependentQuestionsList.length > 0) {
      var dependList = this.props.question.dependentQuestionsList.filter(o => o.selectedOption.includes(values))
      this.setState({ dependantquestionlist: dependList })
    }
  }

  handleselectChange(event) {
    var values = event.target.value
    this.setState({ selecval: event.target.value })
    this.getDropdownDepened(values)

  }

  getDropdownDepened(values){
    if (this.props && this.props.question && this.props.question.dependentQuestionsList && this.props.question.dependentQuestionsList.length > 0) {
      var dependList = this.props.question.dependentQuestionsList.filter(o => o.selectedOption.includes(values))
      this.setState({ dependantquestionlist: dependList })
    }
  }

  inputChangevent(evt) {
    var val = evt.target.type == "number" ? Math.max(0, parseInt(evt.target.value)).toString().slice(0, evt.target.maxLength) : evt.target.value;
    this.setState({ values: val })
  }

  getTextType(element) {
    let name = element.question.toLowerCase()
    let maxLength = name == 'age' ? 3 : (name == 'phone number (optional)' ? 10 : 1000);
    let type = name == 'age' ? 'number' : (name == 'phone number (optional)' ? 'number' : 'text')
    console.log(name,type)
    return (
      <FormControlLabel
        className="getinvolvedtextboxholder"
        name={element.id}
        control={
          <TextField
            type={type}
            value={this.state.values}
            multiline={type=='text'?true:false}
            rows={4}
            onChange={this.inputChangevent}
            name={element.id}
            onInput={(e) => {
              e.target.value = type == "number" ? Math.max(0, parseInt(e.target.value)).toString().slice(0, maxLength) : e.target.value
            }}
          />
        }
      />
    );
  }

  getNumberType(element) {
    let name = element.question.toLowerCase()
    let maxLength = name == 'age' ? 3 : (name == 'phone number(optional)' ? 10 : 1000);
    return (
      <FormControlLabel
        className="getinvolvedtextboxholder"
        name={element.id}
        control={
          <TextField type="number" 
          value={this.state.values}
          inputProps={{
            pattern: "[0-9]*",
          }}
            name={element.id}
            onInput={(e) => {
              e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, maxLength)
              this.setState({ values:  Math.max(0, parseInt(e.target.value)).toString().slice(0, maxLength) })
            }}
          />
        }
      />
    );
  }

  getDateType(element) {
    return (
      <FormControlLabel
        className="getinvolvedtextboxholder"
        name={element.id}
        value={this.state.values}
        onChange={this.inputChangevent}
        control={
          <TextField type="date" name={element.id} />
        }
      />
    );
  }


  getDropDownType(element) {
    try {
      let options = Object.keys(element.optionMap);
      const { t } = this.props;
      return (
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={this.state.selecval}
          onChange={this.handleselectChange}
          name={element.id}
        >
          {
            options.map((o, i) => {
              return <MenuItem value={o}>{element.optionMap[o]}</MenuItem>
            })
          }
        </Select>
      )
    } catch (err) {
      console.log(err);
      var errorObj = {
        component: 'Questionnaire',
        method: 'getDropDownType',
        error: err
      }
      logError(errorObj);
    }
  }


  getRadioType(element) {
    console.log(element)
    let values = element.response != undefined ? element["response"]["value"][0] : '';
    let name = element.id
    console.log(values)
    return <RadioElements type={'parent'} values={values} name={name} element={element} handleChangeRadio={this.handleChangeRadio} ></RadioElements>
    // var radiobuttons = [];
    // let options = Object.keys(element.optionMap);
    // options.map((o, i) => {
    //   radiobuttons.push(
    //     <FormControlLabel
    //       key={i}
    //       id={i}
    //       name={"radio-" + element.id}
    //       value={o}
    //       control={<Radio name={"radio-" + element.id} />}
    //       label={element.optionMap[o]}
    //       onChange={(e) => this.handleRadioSelect(e, element)}
    //     />
    //   );
    // });

    // return <RadioGroup name={element.name}>{radiobuttons}</RadioGroup>;
  }

  getCheckboxType(element) {
    var checkbuttons = [];
    let keys = Object.keys(element.optionMap);
    keys.map((o, i) => {
      let checked = element.response && element.response.value.includes(o) ? true : false;
      checkbuttons.push(
        <CheckboxQues
          key={i}
          value={o}
          checkedFalg={checked}
          name={element.id}
          label={element.optionMap[o]}
          element={element}
          handleChangeCheckbox={this.handleChangeCheckbox}
        >
        </CheckboxQues>
      );
    });
    return <FormGroup>{checkbuttons}</FormGroup>;
  }

  render() {
    const { classes } = this.props;
    const { t } = this.props;
    if (this.props.question) {
      return <>{this.renderQuestion()}</>;
    }
    return null;
  }
}



const mapStateToProps = (state) => {
  let { storeState } = state;
  return {
    templateID: JSON.parse(localStorage.getItem('templateID')) != null ? JSON.parse(localStorage.getItem('templateID')) : storeState.templateID,
    communityuid: storeState.communityId,
    langId: storeState.langId,
    componentbgcolor: storeState.componentbgcolor
  };
};

let newQuestionnaire = withStyles(useStyles)(withTranslation()(Questionnaire));
export default connect(mapStateToProps, {})(newQuestionnaire);